import product from "./financing/product.js";
import positionRecord from "./financing/position-record.js";
import index from "./financing/index.js";
import tradeDay from "./financing/trade-day.js";
import warningRule from "./financing/warning-rule.js";
import warningSetting from "./financing/warning-setting.js";
import warning from "./financing/warning.js";

export default {
    product,
    positionRecord,
    index,
    tradeDay,
    warningRule,
    warningSetting,
    warning
};